import { render, staticRenderFns } from "./NodeScreenEdit.vue?vue&type=template&id=063fac8d&scoped=true"
import script from "./NodeScreenEdit.vue?vue&type=script&lang=js"
export * from "./NodeScreenEdit.vue?vue&type=script&lang=js"
import style0 from "./NodeScreenEdit.vue?vue&type=style&index=0&id=063fac8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063fac8d",
  null
  
)

export default component.exports